import type { PropertyPath } from "@ngt-form/core";

import type { ModelValidationResult } from "src/api/Tmd.dtos";
import type { TMDValidationError } from "src/types/TMDValidationError";

import convertPascalToCamelCasePropertyPath from "./convertPascalToCamelCasePropertyPath";

/**
 * Groups server validation errors under converted form-field paths.
 *
 * Postconditions: Each output error copies type, message and code in source order; other metadata
 * is omitted. Nonempty input produces an empty form-error list and grouped field errors, otherwise
 * returns an empty object. The input result and errors remain unchanged.
 * Assumptions: Paths identify fields. Missing paths retain the existing undefined-key coercion
 * rather than being promoted to form-level errors.
 */
const convertModelValidationResultToFormValidationResult = (validation: ModelValidationResult) => {
    if (validation && validation.errors && validation.errors.length !== 0) {
        const fieldErrors: Record<PropertyPath, TMDValidationError[]> = {};

        for (let error of validation.errors) {
            const propertyPath = convertPascalToCamelCasePropertyPath(error.propertyPath);

            fieldErrors[propertyPath] ??= [];
            fieldErrors[propertyPath].push({
                type: error.type,
                message: error.message,
                code: error.code
            });
        }

        return {
            form: [],
            fields: fieldErrors
        };
    }

    return {};
};

export default convertModelValidationResultToFormValidationResult;
